<template>
  <PageHeader></PageHeader>
  <div class="photo-blog">
    <PhotoCarousel :photos="myPhotoArray" />
    <div class="post-content">
      <!-- your paragraphs, images, etc. -->
      <h2>Wabi Sabi Challenge</h2>

      <p>I found this  <a href="https://www.youtube.com/watch?v=csfr1ht-uCc&t=263s">Youtuber</a> talking about Wabi-Sabi and photography.</p>

      <p>What is Wabi-Sabi, you may be asking yourself?</p>

      <p>Well, I am no expert but it seems to be a Japanese Philosophy. A philosophy that looks at the world in an interesting way.</p>

      <p>It is a philosophy that embraces imperfection. Well, more like accepts reality. That reality being that nothing is truly perfect. Even things that seem perfect under a microscope aren't.</p>

      <p>That is ok, Wabi-Sabi says. This is the nature of reality, and there is beauty in this so called imperfection. Even things that are damaged can still be beautiful, and that damage is just the mark of time.</p>

      <p>In Wabi-Sabi there is a cherishing of old things and that every nick or break can be repaired. Instead of just throwing something out, see the history and beauty in that thing.</p>

      <p>So Wabi-Sabi tends to value nature and its change, the seasons, growth and decay.</p>

      <p>I picked up Wabi-Sabi for Artists, Designers, Poets & Philosophers by Leonard Koren, a Kodak M35 Yellow (very important) Film Camera and 4 rolls of Kodak Color Film.</p>

      <p>The idea with the camera is to just remove any stress or thought about taking pictures. That Kodak camera has no controls outside of turning on flash, which I didn't use.</p>

      <p>The second thing is to remove any thoughts on amazing picture quality. Getting into to photography, there is so much on gear, 4 billion megapixels, when at the end of the day it is about the image. The great
	photographers of the past had none of that technology and still took photos that hold up today.</p>

      <p>Then the last part was to use Wabi-Sabi as an inspiration and philosophy of what to shoot. I took a bunch of photos of things I would overlook, which is elevated in Wabi-Sabi. The simple, the humble, the overlooked
      things of everyday life.</p>


      <p>This was a fun challenge. It was fun to shoot film and it was great to just take stress-free pictures and to look for things I wouldn't normally pay attention to. As well as not care about the outcome just to observe the world and press a clicky thing. </p>


      
    </div>

       
    <div class="text-center p-6">
      <div class="row mt-5">
        <div class="col-12 text-center">
          <p>
            Copyright Jeremy Schwartz&copy; 2025 All rights reserved
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from './PageHeader.vue';
import PhotoCarousel from './PhotoCarousel.vue';
export default {
  name: 'BlogPost',
  components: {
      PageHeader,
      PhotoCarousel
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
	post: {},
	myPhotoArray: []
       



    }
  },
  computed: {
    
  },
  methods: {
   
  },
  mounted() {
      console.log("Mounted:", this.id);


    fetch(`/posts/${this.id}.json`)
      .then(response => response.json())
      .then(data => {
        console.log("Data", data);
        //this.post = data;
        //console.log(this.post.photos);
          this.myPhotoArray = data.photos

fetch(`/posts/${this.id}.html`)
		      .then(response => response.text())
		    .then(data => {
		
			    console.log(data)
			    this.post.content = data
			}
			 )
			 	  
	});
	


  }
}
</script>

<style scoped>
/* all: revert; */

.photo-blog {
  /* center it, cap the width for readability */
  max-width: 700px;
  margin: 0 auto;        /* top/bottom 0, left/right auto = centered */
  padding: 1rem;         /* breathing room on small screens */
}

.photo-blog h1 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;    /* often nice for titles */
}

.photo-blog h2 {
  font-family: 'Roboto', sans-serif;
  font-weight: 700;
  font-size: 2.5rem;
  margin-bottom: 1.5rem;
  text-align: center;    /* often nice for titles */
}

.photo-blog h2 {
  font-family: 'Roboto', sans-serif;
  font-weight: 600;    /* a step down from 700 */
  font-size: 2rem;     /* 32px */
  line-height: 1.3;    
  margin: 1.25rem 0;   /* slightly less vertical space */
}

/* ── Heading Level 3 ── */
.photo-blog h3 {
  font-family: 'Roboto', sans-serif;
  font-weight: 500;    /* lighter still */
  font-size: 1.5rem;   /* 24px */
  line-height: 1.4;
  margin: 1rem 0;      
}

/* ── Smaller Sub‑headings ── */
.photo-blog h4 {
  font-weight: 500;
  font-size: 1.25rem;  /* 20px */
  line-height: 1.4;
  margin: 0.75rem 0;
}

.photo-blog .post-content {
  line-height: 1.6;
  color: #333;
}

.photo-blog .post-content p {
  font-size: 1rem;           /* 16px */
  line-height: 1.6;          /* comfortable reading */
  margin: 0 0 1rem;          /* bottom spacing only */
  color: #333;
}

.photo-blog .post-content ul {
  list-style: disc outside;  /* standard bullet style */
  margin: 0 0 1rem 1.5rem;    /* indent from left + bottom space */
  padding: 0;
}

.photo-blog .post-content ul li {
  margin-bottom: 0.5rem;     /* a bit of breathing room */
}

/* Optional: tighten nested lists */
.photo-blog .post-content ul ul {
  margin-left: 1rem;         /* less indent on nested levels */
  margin-bottom: 0.75rem;
}

.photo-blog .post-content ul li:last-child {
  margin-bottom: 0;          /* no extra space after last item */
}

.photo-blog .post-content a {
  color: #007acc;               /* your link color */
  text-decoration: none;        /* remove default underline */
  border-bottom: 1px dotted;    /* subtle indicator */
  transition: color 0.2s;       /* smooth hover */
}

.photo-blog .post-content a:hover {
  color: #005a9e;               /* darker on hover */
  text-decoration: underline;   /* reinforce it’s a link */
}
/* Optional: tighten padding on very small screens */
@media (max-width: 480px) {
  .photo-blog {
    padding: 0.5rem;
  }
}


</style>
